module.exports = __webpack_public_path__ + "media/images/check-solid-c4e80aaf.svg";